import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { type CarouselProps } from '@silvertours/front-entities';

const paddingInline = (isModernStage: boolean | undefined, value: string) =>
  isModernStage ? '0 0.5rem' : value;

const Container = styled.div<CarouselProps & { $isModernStage?: boolean }>`
  display: flex;
  gap: ${({ theme }) => theme.spacing[20]};
  padding-inline: ${({ $isModernStage }) => paddingInline($isModernStage, '1rem')};

  & > * {
    width: 326px;
  }

  ${({ theme }) => theme.mq('sm')} {
    gap: ${({ theme }) => theme.spacing[40]};

    & > * {
      width: ${({ $isModernStage }) => ($isModernStage ? '389px' : '392px')};
    }

    padding-inline: ${({ $isModernStage }) => paddingInline($isModernStage, '2rem')};
  }

  ${({ theme }) => theme.mq('xl')} {
    gap: ${({ theme }) => theme.spacing[50]};
    padding-inline: ${({ $isModernStage }) =>
      paddingInline($isModernStage, 'clamp(2rem, calc((100vw - 1220px) / 2), 22rem)')};
  }

  ${({ theme }) => theme.mq('xxl')} {
    padding-inline: ${({ $isModernStage }) =>
      paddingInline($isModernStage, 'clamp(2rem, 350px, 22rem)')};
  }
`;

const Wrapper = styled.div<{ $isModernStage?: boolean }>`
  display: block;
  position: relative;
  color: ${({ theme }) => theme.colors.neutral.grey160};
  background-color: ${({ theme }) => theme.colors.neutral.grey20};

  ${({ theme }) => theme.mq('md')} {
    padding-bottom: 2rem;
  }

  ${({ $isModernStage }) =>
    $isModernStage &&
    css`
      background-color: transparent;
    `}

  nav {
    padding-right: ${({ theme }) => theme.spacing[40]};

    ${({ theme }) => theme.mq('sm')} {
      padding-right: 2rem;
    }

    ${({ theme }) => theme.mq('xl')} {
      padding-right: clamp(2rem, calc((100vw - 1220px) / 2), 22rem);
    }

    ${({ theme }) => theme.mq('xxl')} {
      padding-right: clamp(2rem, 350px, 22rem);
    }
  }

  ${({ $isModernStage }) =>
    $isModernStage &&
    css`
      nav {
        padding-right: 0;
      }
    `}
`;

export { Container, Wrapper };
